import { AiCases } from "../../../../features/AiCases";
import { appRouterPaths } from "../../../../services/navigation/urls";
import type { AppRouteProps } from "../../types";

export const aiCasesRouteConfig: AppRouteProps = {
  path: appRouterPaths["ai-cases"].root,
  element: <AiCases />,
  name: "Поиск кейсов",
};
